import React, { createContext, useContext, useState } from 'react';
import { api } from 'app';

const EventsUIContext = createContext();

export function useEventsUIContext() {
  return useContext(EventsUIContext);
}

export function EventsUIProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async input => {
    let query = input.slice(1);
    !query.includes('sort=') && (query = query + '&sort=created_at');
    api
      .get(
        `/adminPanel/events?include=showtimes,organization&include=showtimes,organization&${query}`
      )
      .then(response => {
        setData(response);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const value = {
    fetchData,
    data,
    setData,
    isLoading,
    setIsLoading
  };

  return <EventsUIContext.Provider value={value}>{children}</EventsUIContext.Provider>;
}
